export default __webpack_public_path__ + "static/media/edit.5de789ef.png";